
const themeConfig = {
  antdTheme: {
    primaryColor: "#288BFF",
  },
  admTheme: {
    colorPrimary: "#288BFF",
  },
  cssVars: {
    primaryColor: "#288BFF",
    successColor: "#288BFF",
    textPrimaryColor: "#262626",
    textSecondaryColor: "#1D1D1D",
  },
};

export default themeConfig
